import type { UpdatePaymentTypeAction } from "@app/modules/checkout/types/checkout-actions-types";
import type { PaymentType } from "@app/types/napi-types";

import type { PaymentProvider } from "../../../types/napi-v2";

import { UPDATE_PAYMENT_TYPE } from "../constants/action-types";

export function updatePaymentType(
  payment_type: PaymentType,
  provider: PaymentProvider["provider"]
): UpdatePaymentTypeAction {
  return {
    type: UPDATE_PAYMENT_TYPE,
    provider,
    payment_type
  };
}
